var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticClass:"video-js",attrs:{"data-setup":"{\"controls\": true, \"fluid\": true, \"autoplay\": false, \"preload\": \"auto\"}"}},[_c('source',{attrs:{"src":_vm.interview.file_upload.optimized_url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }